import { render, staticRenderFns } from "./FixedIncomeDurationMethodology.vue?vue&type=template&id=1ac7f7ef&"
import script from "./FixedIncomeDurationMethodology.vue?vue&type=script&lang=js&"
export * from "./FixedIncomeDurationMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports